exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actionDropdown__category___3ud9J {\n  font-weight: bold;\n  margin-right: 5px; }\n\n.actionDropdown__title___2u7qV {\n  margin-right: 5px; }\n\n.actionDropdown__name___1VlWL {\n  color: grey;\n  font-size: 90%; }\n", ""]);

// exports
exports.locals = {
	"category": "actionDropdown__category___3ud9J",
	"title": "actionDropdown__title___2u7qV",
	"name": "actionDropdown__name___1VlWL"
};